function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.166 6.193H.9a.842.842 0 000 1.684h12.184l-4.41 4.411a.842.842 0 101.19 1.191l5.89-5.889a.842.842 0 000-1.191L9.863.51a.842.842 0 10-1.19 1.191l4.492 4.492z",
  fill: "#F58220",
  fillRule: "evenodd"
});

function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgIconArrowRight;